import React, { useEffect } from 'react';

const ServiceWorkerManager: React.FC = () => {
    useEffect(() => {
        if ('serviceWorker' in navigator) {
            const handleMessage = (event: MessageEvent) => {
                if (event.data && event.data.type === 'FORCE_RELOAD') {
                    console.warn('[PWA] Force-Reload triggered by server');
                    // We reload the page to ensure the user gets the latest version accurately.
                    // This is safe because registration.update() was already called in SW.
                    window.location.reload();
                }
            };

            navigator.serviceWorker.addEventListener('message', handleMessage);
            return () => navigator.serviceWorker.removeEventListener('message', handleMessage);
        }
    }, []);

    return null;
};

export default ServiceWorkerManager;
